import React from "react";
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

const Connector = (Component) => {

/**
 * Provide project id and project slug from location's state. Already includes hoc withRouter
 * @component
 * @category HOC
 * @param providedProps
 * @param {number} providedProps.projectId - Identifier of project
 * @param {string} providedProps.projectSlug - Slug of project
 * 
*/

  const WithFromProject = (Component) => {

    class WithFromProject extends React.Component {

      constructor(props) {
        super(props);

        const { state: { projectId, projectSlug } = {} } = props.location;
        this.projectId = projectId;
        this.projectSlug = projectSlug;
      }

      render() {
        return <Component { ...this.props } 
                          projectId = { this.projectId }
                          projectSlug = { this.projectSlug }/>
      }
    }

    return WithFromProject;
  };

  return compose(withRouter, WithFromProject)(Component);
}

export default Connector;
